import React from "react";
import Square from "./Square";
import { calcRow } from "../utils/gameHelpers";

class Board extends React.Component {
  renderSquare(i) {
    return (
      <Square
        value={this.props.squares[i]}
        onClick={() => this.props.onClick(i)}
      />
    );
  }

  render() {
    const { squares, rowsFree, aIsNext } = this.props;

    return (
      <div>
        {[0, 1, 2, 3, 4, 5, 6, 7].map((row) => (
          <div className="board-row" key={row}>
            &nbsp;
            {calcRow(row, squares, rowsFree, aIsNext)}
            {[0, 1, 2, 3, 4, 5, 6, 7].map((col) =>
              this.renderSquare(row * 8 + col)
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default Board;